







import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class EtiquetaPequena extends Vue {
	@Prop({ type: String, required: true }) texto!: string
	@Prop({ type: String, required: true }) cor!: string
}
